export enum RegionalSubstitutionStatus {
  SCHEDULED = "SCHEDULED",
  ACTIVE = "ACTIVE",
  ENDED = "ENDED",
  INACTIVATED = "INACTIVATED",
}

export interface IRegionalSummary {
  id: number;
  name: string;
  email: string | null;
}

export interface IGerenteSummary {
  id: string;
  name: string;
  email: string;
}

export interface IRegionalSubstitution {
  id: string;
  version: number;
  status: RegionalSubstitutionStatus;
  initial_term: string;
  final_term: string;
  created_at: string;
  updated_at?: string;
  deleted_at?: string | null;
  regional: IRegionalSummary;
  user: IGerenteSummary;
}

export interface IRegionalSubstitutionParams {
  meta: {
    page: number;
    perPage?: number;
  };
  search?: string;
  status?: string;
  orderBy?: string;
}

export interface ISubstituteCandidatesParams {
  search?: string;
  orderBy: string;
  perPage: number;
  meta: {
    page: number;
  };
}

export interface ICreateRegionalSubstitution {
  user_id: string;
  regional_id: number;
  initial_term: string;
  final_term: string;
}

export interface IUpdateRegionalSubstitution {
  version: number;
  initial_term?: string;
  final_term?: string;
}

export interface IRegionalSubstitutionFilters {
  search?: string;
  status?: string;
  order?: {
    [key: string]: string;
  };
  meta?: {
    page?: number;
    perPage?: number;
  };
}

